module.exports = __webpack_public_path__ + "static/media/lead_generated.13ebe234.svg";